export interface Chip {
    name: string | null;
    label: string | null;
    active: boolean  | null;
    show: boolean  | null;
}
export class ChipModel implements Chip{
    name: string | null = null;
    label: string | null = null;
    active: boolean | null = null;
    show: boolean | null = null;

    constructor(JSONdata: Chip) {
        this.name = JSONdata.name;
        this.label = JSONdata.label;
        this.active = JSONdata.active;
        this.show = JSONdata.show;
    }
}
